import { render, staticRenderFns } from "./BatchUnbindMainCard.vue?vue&type=template&id=2c88befb&scoped=true"
import script from "./BatchUnbindMainCard.vue?vue&type=script&lang=js"
export * from "./BatchUnbindMainCard.vue?vue&type=script&lang=js"
import style0 from "./BatchUnbindMainCard.vue?vue&type=style&index=0&id=2c88befb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88befb",
  null
  
)

export default component.exports